import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dev/ee-components';
import { useParams } from 'react-router';
import { ProductCode } from '@dev/ee-api/ee-api-models';
import { Box } from '@material-ui/core';

import { useEnableContactHistory } from '@/services/hooks/useEnableContactHistory';
import { CampaignCreatorType } from '@/services/dictionaries/Paths';
import { useDashboardElementVisibility } from '@/services/hooks/useDashboardElementVisibility';
import { LockIcon } from '@/services/icons/LockedIcon';
import { BillingPaths, pathsParams } from '@/services/dictionaries/Paths';

import { SavedLockedInfo } from '@/components/TemplateEditor/components/SavedLockedInfo';
import { SectionWrapperStep3 } from '../../../styled';
import { ManageIPPools } from './components/ManageIPPools';
import { AutoresponderOptions } from './components/Autoresponder';
import { WinnerSelection } from '../WinnerSelection';
import { Timing } from './components/Timing';

export const Sending = (): JSX.Element => {
    const { t } = useTranslation();
    const { type } = useParams<{ name: string; type: string }>();
    const isAbCampaign = type === CampaignCreatorType.AB;
    const isAutoresponderAvailable = useEnableContactHistory();
    const { upselling: { isSendTimeOptimizationUpsellingVisible } } = useDashboardElementVisibility();

    const clickUpgradeBtn = (): void => {
            window.location.href = `${location.origin}${BillingPaths.BillingPlanList.replace(
                pathsParams.productCode,
                ProductCode.CreatorSuite.toLowerCase()
            )}`;
        };

    return (
        <SectionWrapperStep3>
            <Typography variant="h2">{t('sending')}</Typography>
            {isSendTimeOptimizationUpsellingVisible ? 
            <Box mt='32px'>
                <SavedLockedInfo
                    isSidebar={false}
                    title={{ text: t('sendtimeoptimization'), icon: <LockIcon width={15} height={15} /> }}
                    body={{ subtitle: t('sendtimeoptimizationupselling_subtitle'), text: t('sendtimeoptimizationupselling_desc') }}
                    button={{
                        startIcon: <LockIcon width={20} height={20} />,
                        text: t('upgradetounlock'),
                        onClick: clickUpgradeBtn,
                    }}
                />
            </Box> : 
            <>
                <WinnerSelection />

                {isAutoresponderAvailable && !isAbCampaign && <AutoresponderOptions />}
                <ManageIPPools />
                {!isAbCampaign && <Timing />}
            </>}
        </SectionWrapperStep3>
    );
};
